import styled from 'styled-components';
import { Poppins } from './Poppins';

export const StyledInputLabel = styled(Poppins).attrs((p) => {
  return { px: 14, ...p };
})`
  font-weight: 500;
  color: ${({ theme }) => theme.colors.cflowerBlue};
  display: block;
`;

export const LabelRow = styled.div`
  display: flex;
  gap: 4px;
`;

export const CounterRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 10px;
`;

export const CharCounter = styled(Poppins).attrs((p) => {
  return { px: 12, ...p };
})<{ $over?: boolean }>`
  font-weight: 500;
  white-space: nowrap;
  color: ${({ theme, $over }) => ($over ? theme.colors.error : theme.colors.cflowerBlue)};
`;
